import dayjs from "dayjs";
import { CURRENT_SEASON, CURRENT_SEASON_LABEL } from "../const";
import { Timeframe } from "../const";

export const nbaFinalsDates = {
  "2023-24": "2024-06-17",
  "2022-23": "2023-06-12",
  "2021-22": "2022-06-16",
  "2020-21": "2021-07-20",
  "2019-20": "2020-10-11",
  "2018-19": "2019-06-13",
  "2017-18": "2018-06-08",
  "2016-17": "2017-06-12",
  "2015-16": "2016-06-19",
  "2014-15": "2015-06-16",
  "2013-14": "2014-06-15",
  "2012-13": "2013-06-20",
  "2011-12": "2012-06-21",
  "2010-11": "2011-06-12",
  "2009-10": "2010-06-17",
  "2008-09": "2009-06-14",
  "2007-08": "2008-06-17",
  "2006-07": "2007-06-14",
  "2005-06": "2006-06-20",
};

export const nbaSeasonEndDates = {
  "2009-10": "2010-04-14",
  "2010-11": "2011-04-13",
  "2011-12": "2012-04-26",
  "2012-13": "2013-04-17",
  "2013-14": "2014-04-16",
  "2014-15": "2015-04-15",
  "2015-16": "2016-04-13",
  "2016-17": "2017-04-12",
  "2017-18": "2018-04-11",
  "2018-19": "2019-04-10",
  "2019-20": "2020-08-14",
  "2020-21": "2021-05-16",
  "2021-22": "2022-04-10",
  "2022-23": "2023-04-09",
  "2023-24": "2024-04-14",
  "2024-25": "2025-04-13",
};

export const nbaStartDates = {
  "2023-24": "2023-10-24",
  "2022-23": "2022-10-18",
  "2021-22": "2021-10-19",
  "2020-21": "2020-12-22",
  "2019-20": "2019-10-22",
  "2018-19": "2018-10-16",
  "2017-18": "2017-10-17",
  "2016-17": "2016-10-25",
  "2015-16": "2015-10-27",
  "2014-15": "2014-10-28",
  "2013-14": "2013-10-29",
  "2012-13": "2012-10-30",
  "2011-12": "2011-12-25",
  "2010-11": "2010-10-26",
  "2009-10": "2009-10-27",
  "2008-09": "2008-10-28",
  "2007-08": "2007-10-30",
  "2006-07": "2006-10-31",
  "2005-06": "2005-11-01",
};

export function nbaSeasonFromDate(date: string) {
  const previousFinalsDate = Object.values(nbaFinalsDates).find(
    (finalsDate) => {
      return dayjs(date).isAfter(dayjs(finalsDate));
    }
  );

  const yearToParse = previousFinalsDate
    ? dayjs(previousFinalsDate).format("YY")
    : dayjs(date).format("YY");
  const year = Number(yearToParse);
  return `20${year}-${year + 1}`;
}

export function nbaSeasonFromYear(seasonStartYear: number) {
  return `${seasonStartYear.toString()}-${(seasonStartYear + 1).toString().slice(-2)}`;
}

export function nbaSeasonFromYearShort(seasonStartYear: number) {
  return `${seasonStartYear.toString().slice(-2)}-${(seasonStartYear + 1).toString().slice(-2)}`;
}

const getSeasonStartDate = (season: number) => {
  const nextYear = (season + 1).toString().slice(-2);
  return nbaStartDates[`${season}-${nextYear}` as keyof typeof nbaStartDates];
};

export const SEASON_RANGES = [
  {
    label: Timeframe.ONE_SEASON,
    start: getSeasonStartDate(CURRENT_SEASON - 1),
    end: dayjs().format("YYYY-MM-DD"),
  },
  {
    label: Timeframe.TWO_SEASONS,
    start: getSeasonStartDate(CURRENT_SEASON - 2),
    end: dayjs().format("YYYY-MM-DD"),
  },
  {
    label: Timeframe.FIVE_SEASONS,
    start: getSeasonStartDate(CURRENT_SEASON - 5),
    end: dayjs().format("YYYY-MM-DD"),
  },
  {
    label: Timeframe.MAX,
    start: getSeasonStartDate(2005),
    end: dayjs().format("YYYY-MM-DD"),
  },
];

export const PROJECTION_SEASON_RANGES = [
  {
    label: Timeframe.ONE_SEASON,
    start: nbaSeasonEndDates[CURRENT_SEASON_LABEL],
    end: dayjs().add(1, "year").format("YYYY-MM-DD"),
  },
  {
    label: Timeframe.TWO_SEASONS,
    start: nbaSeasonEndDates[CURRENT_SEASON_LABEL],
    end: dayjs().add(2, "year").format("YYYY-MM-DD"),
  },
  {
    label: Timeframe.FIVE_SEASONS,
    start: nbaSeasonEndDates[CURRENT_SEASON_LABEL],
    end: dayjs().add(5, "year").format("YYYY-MM-DD"),
  },
  {
    label: Timeframe.MAX,
    start: nbaSeasonEndDates[CURRENT_SEASON_LABEL],
    end: dayjs().add(5, "year").format("YYYY-MM-DD"),
  },
];
